import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TextField, MenuItem, Button } from "@mui/material";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const RedirectEC = (props) => {

    const { userDetails } = useSelector((state) => state.user);
    const [commonExpCenter, setExpCenter] = useState([]);
    const [selectedExperienceCenterFrom, setSelectedExperienceCenterFrom] = useState("");
    const [selectedExperienceCenterTo, setSelectedExperienceCenterTo] = useState("");
    const [redirectECData, setRedirectECData] = useState([])

    useEffect(() => {
        expCenters();
        fetchRedirectEC();
    }, []);

    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user =>
                userDetails.experienceCenterId.includes(user._id)
            );
            setExpCenter(matchedUsers);
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        props.setLoading(false);
    };

    const fetchRedirectEC = async () => {
        try {

            const response = await HttpService.getRedirectEC();
            setRedirectECData(response.data)
        } catch (error) {
            console.error("fetchEC ->", error)
        }
    };

    const handleSubmit = async () => {
        try {
            props.setLoading(true)
            let obj = {
                createdBy: userDetails.name,
                redirectECFrom: selectedExperienceCenterFrom,
                redirectECTo: selectedExperienceCenterTo
            };

            const response = await HttpService.redirectEC(obj);
            setSelectedExperienceCenterFrom("")
            setSelectedExperienceCenterTo("")
            fetchRedirectEC();
            props.setLoading(false)
        } catch (error) {
            console.error("Error ->", error);
        }
    };


    const handleDelete = async (item) => {
        try {
            props.setLoading(true);
            const response = await HttpService.deleteRedirectEC(item)
            fetchRedirectEC();
            props.setLoading(false);
        } catch (error) {
            console.error("Delete error ->", error)
        }
    };


    return (
        <div>
            {/* <h3 style={{
                textAlign: 'center',
                marginBottom: '30px',
                marginTop: '20px',
                fontWeight: 500
            }}>
                Create Redirection
            </h3> */}

            {/* Redirect From EC Dropdown */}
            <TextField
                select
                id="redirect-from-ec"
                value={selectedExperienceCenterFrom}
                label="Redirect From EC"
                name="redirectFromEC"
                onChange={(e) => setSelectedExperienceCenterFrom(e.target.value)}
                variant="outlined"
                style={{ width: '30%', marginRight: '2%' }}
                size="small"
            >
                {commonExpCenter.map((center) => (
                    <MenuItem key={center._id} value={center.name}>
                        {center.name}
                    </MenuItem>
                ))}
            </TextField>

            {/* Redirect To EC Dropdown */}
            <TextField
                select
                id="redirect-to-ec"
                value={selectedExperienceCenterTo}
                label="Redirect To EC"
                name="redirectToEC"
                onChange={(e) => setSelectedExperienceCenterTo(e.target.value)}
                variant="outlined"
                style={{ width: '30%' }}
                size="small"
            >
                {commonExpCenter.map((center) => (
                    <MenuItem key={center._id} value={center.name}>
                        {center.name}
                    </MenuItem>
                ))}
            </TextField>

            {/* Submit Button */}
            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={!selectedExperienceCenterFrom || !selectedExperienceCenterTo}
                style={{ marginLeft: '40px' }}
            >
                Submit
            </Button>


            <div style={{ marginTop: '50px'}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>SL No.</StyledTableCell>
                            <StyledTableCell>Redirected From</StyledTableCell>
                            <StyledTableCell>Redirected To</StyledTableCell>
                            <StyledTableCell>Action</StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {redirectECData?.map((item, index) => (
                            <TableRow key={item._id || index}>
                                <StyledTableCell>{index + 1}</StyledTableCell>
                                <StyledTableCell>{item.redirectECFrom}</StyledTableCell>
                                <StyledTableCell>{item.redirectECTo}</StyledTableCell>
                                <StyledTableCell>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={() => handleDelete(item)}
                                        size="small"
                                    >
                                        Delete
                                    </Button>
                                </StyledTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(RedirectEC);